'/create-folder/:parentId';

import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postPrivateProjectBankItem = async (projectId, fileItem) => {
  const apiPath = `project-bank/private/project/${projectId}/create-file-items`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { fileItems: [fileItem] },
  });

  const response = await axios(signedRequest);

  return response.data;
};
